const u = up.util;
const e = up.element;
up.OptionsParser = class OptionsParser {
    constructor(element, options, parserOptions = {}) {
        this._options = options;
        this._element = element;
        this._fail = parserOptions.fail;
        this._closest = parserOptions.closest;
        this._attrPrefix = parserOptions.attrPrefix || 'up-';
        this._defaults = parserOptions.defaults ?? {};
    }
    string(key, keyOptions) {
        this.parse(e.attr, key, keyOptions);
    }
    boolean(key, keyOptions) {
        this.parse(e.booleanAttr, key, keyOptions);
    }
    number(key, keyOptions) {
        this.parse(e.numberAttr, key, keyOptions);
    }
    booleanOrString(key, keyOptions) {
        this.parse(e.booleanOrStringAttr, key, keyOptions);
    }
    booleanOrNumber(key, keyOptions) {
        this.parse(e.booleanOrNumberAttr, key, keyOptions);
    }
    booleanOrNumberOrString(key, keyOptions) {
        this.parse(e.booleanOrNumberOrStringAttr, key, keyOptions);
    }
    json(key, keyOptions) {
        this.parse(e.jsonAttr, key, keyOptions);
    }
    renderCallback(key, keyOptions = {}) {
        let attrReader = (link, attr) => up.RenderOptions.callbackAttr(link, attr, key);
        this.parse(attrReader, key, keyOptions);
    }
    parse(attrReader, key, keyOptions = {}) {
        const attrNames = u.wrapList(keyOptions.attr ?? this._attrNameForKey(key));
        let value = this._options[key];
        for (let attrName of attrNames) {
            value ??= this._parseFromAttr(attrReader, this._element, attrName);
        }
        if (this._defaults !== false) {
            value ??= keyOptions.default ?? this._defaults[key];
        }
        if (u.isDefined(value)) {
            let normalizeFn = keyOptions.normalize;
            if (normalizeFn) {
                value = normalizeFn(value);
            }
            this._options[key] = value;
        }
        let failKey;
        if (this._fail && (failKey = up.fragment.failKey(key))) {
            const failAttrNames = u.compact(u.map(attrNames, (attrName) => this._deriveFailAttrName(attrName)));
            this.parse(attrReader, failKey, { ...keyOptions, attr: failAttrNames });
        }
    }
    include(optionsFn, parserOptions) {
        let fnResult = optionsFn(this._element, this._options, { defaults: this._defaults, ...parserOptions });
        Object.assign(this._options, fnResult);
    }
    _parseFromAttr(attrValueFn, element, attrName) {
        if (this._closest) {
            return e.closestAttr(element, attrName, attrValueFn);
        }
        else {
            return attrValueFn(element, attrName);
        }
    }
    _deriveFailAttrName(attr) {
        return this._deriveFailAttrNameForPrefix(attr, this._attrPrefix + 'on-') ||
            this._deriveFailAttrNameForPrefix(attr, this._attrPrefix);
    }
    _deriveFailAttrNameForPrefix(attr, prefix) {
        if (attr.startsWith(prefix)) {
            return `${prefix}fail-${attr.substring(prefix.length)}`;
        }
    }
    _attrNameForKey(option) {
        return `${this._attrPrefix}${u.camelToKebabCase(option)}`;
    }
};
